import setCarePlanMedicalNote from './setCarePlanMedicalNote';
import addCarePlanMedicalNotes from './addCarePlanMedicalNotes';
import updateCarePlanMedicalNote from './updateCarePlanMedicalNote';
import removeCarePlanMedicalNote from './removeCarePlanMedicalNote';

export default {
  addCarePlanMedicalNotes,
  removeCarePlanMedicalNote,
  setCarePlanMedicalNote,
  updateCarePlanMedicalNote,
};
